<template>
  <ul class="files-list">
    <li
      v-for="file in files"
      :key="file.id"
      class="files-list__file"
    >
      <a
        v-if="file.url"
        :href="file.url"
        target="_blank"
        class="files-list__title"
      >
        {{ file.filename || file.name }}
      </a>
      <span v-else class="files-list__title">
        {{ file.filename || file.name }}
      </span>
      <DSConfirmButton :on-click="() => $emit('remove', file)">
        Remove
      </DSConfirmButton>
    </li>
  </ul>
</template>

<script>
import DSConfirmButton from './forms/DSConfirmButton'

export default {

  name: 'NominationFiles',

  components: {
    DSConfirmButton,
  },

  props: {
    files: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
  li {
    background: none;
    padding-left: 0;
  }
  .files-list {
    margin: 1rem auto;
    background-color: rgba(0,0,0,.025);
    border: 1px solid rgba(0,0,0,.1);
    border-radius: 4px;
    padding: 1rem;

    &__file {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    &__title {
      margin-right: 0.5em;
    }
  }
</style>
